import { IRouteInfo } from '@components-common/routes';
import {
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router-dom';

const handleMatchException = (error: any) => {
  const regex = /id\s+"([^"]+)"/;
  try {
    const match = error.match(regex);
    if (match) {
      const id = match[1]; // This is the extracted ID
      console.log('Extracted ID:', id);
    } else {
      console.log('No ID found in the error message.');
    }
  } catch (sndError) {
    console.log('Error', sndError);
  }
};

const createReactRouter = (routes: IRouteInfo[]) => {
  try {
    const routesResult = createRoutesFromElements(routes as any);
    const router = createBrowserRouter(routesResult, { window: window });
    return router;
  } catch (error) {
    handleMatchException(error);
    return undefined;
  }
};

const create = (routes: IRouteInfo[]) => {
  const router = createReactRouter(routes);
  const onRouteChange = (callback: any) => {
    router!.subscribe((state: any) => {
      callback(state);
    });
  };
  return {
    getRouter: () => router,
    onRouteChange,
  };
};

export const routerFactory = (routes: IRouteInfo[] = []) => {
  let result = [...routes];
  return {
    add: (route: IRouteInfo[]) => {
      result = [...result, ...route];
    },
    create: () => create(result),
    createFiltered: (filter: (route: IRouteInfo) => boolean) =>
      create(result.filter(filter)),
  };
};
